import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  readonly title: string;
  readonly description?: string;
  readonly icon?: React.ReactNode;
};

export function AuroraHeader({ title, description, icon }: Props) {
  return (
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        pt: { xs: 4, md: 6 },
        pb: { xs: 3, md: 5 },
        mb: 4,
      }}
    >
      <Stack direction="row" spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
        {icon}
        <Typography variant="h1" sx={{ fontSize: { xs: 44, md: 72 } }}>
          {title}
        </Typography>
      </Stack>
      {description && (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            maxWidth: 880,
            whiteSpace: 'pre-line',
            fontSize: { xs: 16, md: 18 },
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
}
